<template>
	<div>
		<div @click="showModal">
			<button class="fake-anchor">Remove a company set</button>
		</div>

		<modal v-if="isModalVisible" @close="closeModal" @backgroundClicked="closeModal">
			<h2 slot="header">Remove a Company Set</h2>
			<div slot="body">
				<company-id-uploader @close="closeModal" @arrayChanged="updateFiles" :uploadedFiles="uploadedFiles"></company-id-uploader>
			</div>
		</modal>
	</div>	
</template>

<script>
	import {FontAwesomeIcon} from '@fortawesome/vue-fontawesome';
	import InputButton from '../reusable/InputButton'
	import Modal from '../reusable/Modal'
	import CompanyIdUploader from '../reusable/CompanyIdUploader'	

	export default {
		name: 'UploadCompanies',
		data() {
			return {
				isModalVisible: false,
				files:[]
			}
		},
		components: {
			FontAwesomeIcon,
			InputButton,
			Modal,
			CompanyIdUploader
		},
		methods: {
			showModal() {
				this.isModalVisible = true
			},
			closeModal() {
				this.isModalVisible = false;
			},
			updateFiles(val) {
				this.$emit('arrayChanged', val)
			}
		},
		props: ['uploadedFiles']
	}
</script>

<style lang="scss" scoped>
	.fake-anchor{
		cursor:pointer;
	}
</style>
